import type { Theme } from 'baseui';
const RELATIONSHIP_POPOVER_Z_INDEX = 5;
export const NOTIFICATION_OVERRIDES = {
  Body: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      marginTop: $theme.sizing.scale300,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      width: 'unset',
      borderRadius: $theme.borders.radius400
    })
  }
};
export const RELATIONSHIP_TOOLTIP_OVERRIDES = {
  Body: {
    style: {
      zIndex: RELATIONSHIP_POPOVER_Z_INDEX
    }
  }
};
export const RELATIONSHIP_SELECT_OVERRIDES = {
  Popover: {
    props: {
      overrides: {
        Body: {
          style: {
            zIndex: RELATIONSHIP_POPOVER_Z_INDEX
          }
        }
      }
    }
  }
};